import { render, staticRenderFns } from "./IconDiamondButton.vue?vue&type=template&id=2c8de352&scoped=true&"
import script from "./IconDiamondButton.vue?vue&type=script&lang=js&"
export * from "./IconDiamondButton.vue?vue&type=script&lang=js&"
import style0 from "./IconDiamondButton.vue?vue&type=style&index=0&id=2c8de352&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8de352",
  null
  
)

export default component.exports